import BlockContent from '@sanity/block-content-to-react';
import { imageUrlBuilder, portableTextSerializer } from '@/utils/helpers';
import Image from 'next/image';
import React from 'react';
import styles from './styles.module.css';

interface TalentProps {
  name: string;
  role?: string;
  description?: Record<string, unknown>[];
  photo?: Record<string, unknown>;
  alignment?: string;
  bgColor?: string;
  textColor?: string;
}

const Talent: React.FC<TalentProps> = ({ name, role, description, photo, alignment = 'left', bgColor, textColor }) => {
  let imgUrl = '';
  if (photo && photo.asset) {
    imgUrl = photo && imageUrlBuilder.image(photo.asset).width(128).height(128).auto('format').quality(80).url();
  } else {
    imgUrl = null;
  }

  return (
    <div
      className={`${styles.talent} ${styles[alignment]}`}
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      <div className={styles.profile}>
        <div className={styles.profileInfo}>
          <h3 className={styles.name}>{name}</h3>
          <hr className={styles.separator} />
          <p className={styles.role}>{role}</p>
        </div>
        {imgUrl && (
          <div className={styles.profilePicture}>
            <Image src={imgUrl} alt={name} width={128} height={128} />
          </div>
        )}
      </div>
      <div className={styles.content}>
        {description && <BlockContent blocks={description} serializers={portableTextSerializer} />}
      </div>
    </div>
  );
};

export default Talent;
